import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import AlertContactForm from './AlertContactForm';
import '../assets/css/WebDevelopment.css';
import Img24 from '../assets/img/Img24.png';
import Img25 from '../assets/img/Img25.png';
import { Link } from 'react-router-dom';
import dsRoadmap from '../assets/img/Diploma_DS.png';
import fsdRoadmap from '../assets/img/Diploma_FSD.png';
import studenthero from '../assets/img/student_hero.png';




const Diploma = () => {
  const [toggle] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    
      <>
  <Helmet>
    <title>Diploma in Full Stack Development & Data Science | Techblume</title>
    <meta name="description" content="Join Techblume's 8-month Diploma in Full Stack Development and Data Science. Hands-on training, global certification, and career support." />
    <meta name="robots" content="index, follow" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link rel="canonical" href="https://techblume.io/diploma" />

    {/* Open Graph / Facebook */}
    <meta property="og:title" content="Diploma in Full Stack & Data Science | Techblume" />
    <meta property="og:description" content="Get certified with Techblume’s 8-month diploma course in Full Stack and Data Science. Apply today!" />
    <meta property="og:url" content="https://techblume.io/diploma" />
    <meta property="og:image" content="https://techblume.io/path-to-your-social-banner.jpg" />
    <meta property="og:type" content="website" />

    {/* Twitter */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Diploma in Full Stack & Data Science | Techblume" />
    <meta name="twitter:description" content="Apply for Techblume's 8-month diploma to build a career in Full Stack or Data Science with industry-level skills." />
    <meta name="twitter:image" content="https://techblume.io/path-to-your-social-banner.jpg" />
  </Helmet>


      {toggle && <AlertContactForm />}

      {/* Course Section */}
      <div className="wd-course">
        <div className="wd-section1" style={{ paddingBottom: '0px', marginBottom: '0px' }}>
          <img src={Img25} alt="Img25" style={{ marginBottom: '0px' }} />

          <section style={{ marginBottom: '10px' }}>
            <h1 style={{ marginBottom: '10px' }}>
              Launch Your Journey as a{' '}
              <span>International Diploma in Full Stack Development / Data Science</span>
            </h1>
            <p style={{ marginBottom: '20px' }}>
              Gain hands-on skills and earn an industry-recognized certification to unlock top job
              opportunities worldwide. Master the latest technologies through real-world projects
              and expert mentorship. Build a global-ready portfolio and launch your career with
              confidence.
            </p>

            <div className="booking-button" style={{ textAlign: 'center', marginTop: '20px', display: 'flex', justifyContent: 'left', gap: '10px' }}>
              <Link
                to="/bookings"
                style={{
                  display: 'inline-block',
                  padding: '10px 20px',
                  backgroundColor: '#007bff',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '5px',
                  fontWeight: 'bold',
                  gap: '20px'
                }}
              >
                Enroll Now!
              </Link>
               <a
            href="https://wa.me/919686430320?text=I%20am%20interested%20in%20Techblume%20Career%20Course%20"
            target="_blank"
            rel="noopener noreferrer"
            
             className="whatsapp-cta"
          >
             <span className="wa-icon">💬</span>
             <span className="wa-text">Chat on WhatsApp</span>
          </a>
            </div>
          </section>

          {/* Roadmap Section */}
          <div
            className="wd-section2"
            style={{ marginTop: '20px', paddingTop: '0px', marginBottom: '0px' }}
          >
            <h2 style={{ marginTop: '0px', marginBottom: '10px' }}>
              International Full Stack Development Certification Roadmap
            </h2>
            <img
              src={fsdRoadmap}
              alt="fsd-roadmap"
              style={{ marginTop: '10px', marginBottom: '30px' }}
            />

            <h2 style={{ marginTop: '0px', marginBottom: '10px' }}>
              International Data Science Certification Roadmap
            </h2>
            <img
              src={dsRoadmap}
              alt="ds-roadmap"
              style={{ marginTop: '10px', marginBottom: '0px' }}
            />
          </div>
        </div>
      </div>
      {/*Funding Section */}
      
          <div className='Projects-page'>
            
      
             <div className='project-section2'>
                <h1>Student Funding</h1>
                <p>Apply for Student Funding — Fast, Simple & Free</p>
                <section>
  
                <img src={studenthero} alt="studenthero"   style={{ width: '400px', height: '250px', marginLeft: '-19px' }}  />
                
                  
                  <main>
                      <h2 className="blue-heading">Student Hero</h2>
                      <h1>Techblume has partnered with <b>STUDENT HERO </b>to give our students access to a free, all-in-one platform to compare and apply for education funding. It's secure, simple, and designed to make funding your studies easier than ever.</h1>
                     {/* Apply Now Button */}
                    <a href="https://landbot.pro/v3/H-2740333-I5PJCXGRK7YZOO13/index.html" className="apply-button">Apply Now</a>
                  </main>
                </section>
                     
             </div>
          </div>

      {/* FAQ Section */}
      <div className="wd-course" style={{ marginTop: '0px' }}>
        <div className="wd-section3" style={{ paddingTop: '0px', marginTop: '0px' }}>
          <div>
            <img src={Img24} alt="Img24" style={{ marginTop: '0px' }} />
            <section>
              <h1 style={{ marginTop: '20px' }}>
                <span>FAQ</span>
              </h1>
              <div style={{ marginTop: '10px' }}>
                <strong>Q:</strong>{' '}
                <span>What equipment do I need for the course?</span> <br />
                <strong>A:</strong>{' '}
                <span>
                  You’ll need a laptop (minimum 4GB RAM recommended) and a stable Wi-Fi connection
                  to fully participate in all live classes, assignments, and projects.
                </span>
                
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Diploma;
